import { FC } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useGameDataContext } from "@context/GameDataContext";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import vblLogo from "../../assets/images/vblLogo.png";

const TeamToggleButton: FC<{
  value: string;
  text: string;
  avatarUrl?: string | null;
}> = ({ value, text, avatarUrl }) => (
  <ToggleButton value={value} fullWidth>
    <Box display="flex" gap={2} alignItems={"center"} flexDirection={"column"}>
      {avatarUrl ? <Avatar src={avatarUrl} /> : null}
      <Typography>{text}</Typography>
    </Box>
  </ToggleButton>
);

const ChallengeTeamSelector: FC = () => {
  const {
    challenge: { team },
    setTeam,
  } = useSelectedChallengeContext();
  const { game } = useGameDataContext();
  const team1 = game?.gameData?.team1 || {
    shortName: "A",
    iconUrl: null,
    clubCode: "A",
  };
  const team2 = game?.gameData?.team2 || {
    shortName: "B",
    iconUrl: null,
    clubCode: "B",
  };

  return (
    <Card variant="elevation" elevation={5} sx={{ width: "250px" }}>
      <CardHeader
        title={"Challenge genommen von"}
        titleTypographyProps={{ variant: "subtitle1", align: "center" }}
        sx={{ pb: 0 }}
      />
      <CardContent>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={3}
        >
          <ToggleButtonGroup
            exclusive
            value={team}
            color={"primary"}
            onChange={(event, value) => {
              setTeam(value);
            }}
          >
            <TeamToggleButton
              value={"team1"}
              text={team1.clubCode || team1.shortName}
              avatarUrl={team1.iconUrl}
            />
            <TeamToggleButton
              value={"team2"}
              text={team2.clubCode || team2.shortName}
              avatarUrl={team2.iconUrl}
            />
            <TeamToggleButton value={"ref"} text={"ref"} avatarUrl={vblLogo} />
          </ToggleButtonGroup>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChallengeTeamSelector;
